import { widgetAnalytics } from "@/components/icons/SVGIcons";
import {
  returnCurrentTabStateJSON,
  returnOpenWidgetsArray,
  returnOpenWidgetsObject,
} from "@/lib/widgetHelperFunctions";
import { updateWorkspaceTabActionUpdate } from "@/store/workspacesTabsStoreACTIONS";
import { useAuth0 } from "@auth0/auth0-react";
import "ag-charts-enterprise";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import AnalyticsSidebarOptions from "./AnalyticsSidebarOptions";
import IndexBrokerRank from "./BrokerRank/BrokerRankIndex";
import IndexClientSummary from "./ClientSummaryReport/IndexClientSummary";
import CounterpartyReportIndex from "./CounterpartyReport/CounterpartyReportIndex";
import IndexFlowAnalysis from "./FlowAnalysis/IndexFlowAnalysis";
import TransactionCostIndex from "./TransactionCost/TransactionCostIndex";
import analyticDataStore from "@/store/analyticsDataStore";
import { mockDataReduced } from "@/store/analyticsFakeData/mockData";

function switchForAnalytics(id: number) {
  switch (id) {
    case 1:
      return <IndexClientSummary />;
    case 2:
      return <IndexFlowAnalysis />;
    case 3:
      return <IndexBrokerRank />;
    case 4:
      return <TransactionCostIndex />;
    case 5:
      return <CounterpartyReportIndex />;
    default:
      return <IndexClientSummary />;
  }
}

function updateAnalyticsWidgetConfig({
  cryptoID,
  activeId,
  isOpenSideBar,
  getAccessTokenSilently,
}: {
  cryptoID: string;
  activeId: number;
  isOpenSideBar: boolean;
  getAccessTokenSilently: Function;
}) {
  const currentTabStateJSON = returnCurrentTabStateJSON();
  const openWidgetsArr = returnOpenWidgetsArray();
  const openWidgetObject = returnOpenWidgetsObject(cryptoID);

  const arrWithUpdatedOpenWidgetData = openWidgetsArr!.map((widget: any) => {
    const currentWidgetSettings = {
      activeId: activeId,
      isOpenSideBar: isOpenSideBar,
    };

    if (widget.i == openWidgetObject.i) {
      return {
        ...widget,
        analyticsSettings: currentWidgetSettings,
      };
    }
    return widget;
  });
  // Add the data to the widget.
  updateWorkspaceTabActionUpdate(
    arrWithUpdatedOpenWidgetData,
    currentTabStateJSON,
    getAccessTokenSilently,
    true,
  );
}

const AnalyticsIndex = ({ cryptoID }: { cryptoID: string }) => {
  const { theme } = useTheme();
  const { getAccessTokenSilently } = useAuth0();

  const currentAnalytcisStoreData = analyticDataStore(
    (state) => state.analyticData,
  );
  const updateAnalyticDataStore = analyticDataStore(
    (state) => state.updateAnalyticData,
  );

  const [firstLoad, setFirstLoad] = useState(false);
  useEffect(() => {
    // replace with an API Call eventually
    if (currentAnalytcisStoreData.length == 0) {
      updateAnalyticDataStore(mockDataReduced);
    }
    setFirstLoad(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openWidgetObject = cryptoID
    ? returnOpenWidgetsObject(cryptoID)
    : undefined;

  const [activeId, setActiveId] = useState(
    openWidgetObject?.analyticsSettings?.activeId ?? 1,
  );
  const [isOpenSideBar, setIsOpenSideBar] = useState(
    openWidgetObject?.analyticsSettings?.isOpenSideBar == true ? true : false,
  );

  useEffect(() => {
    if (firstLoad) {
      updateAnalyticsWidgetConfig({
        cryptoID,
        activeId,
        isOpenSideBar,
        getAccessTokenSilently,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeId, isOpenSideBar]);

  return (
    <div className="g-side-bar ag-unselectable ag-side-bar-left ag-focus-managed flex h-full w-full">
      <div
        className={` min-w-10 border-l border-r pt-1 ${theme == "dark" ? "matchingAgSidebarBorderDark" : "matchingAgSidebarBorder"}`}
      >
        <div className="mt-3 flex w-5 rotate-90">
          <div
            className={`ag-button ag-side-button-button flex flex-row border border-b border-t px-3 ${theme == "dark" ? "matchingAgSidebarBorderDark" : "matchingAgSidebarBorder"}`}
            onClick={() => setIsOpenSideBar((prev) => !prev)}
          >
            <div className="flex items-center justify-center gap-1">
              <div className="h-4 w-4">{widgetAnalytics}</div>

              <div>Analytics</div>
            </div>
          </div>
        </div>
      </div>
      {/* SlideIn sidebar to choose analytics from */}
      {isOpenSideBar && (
        <AnalyticsSidebarOptions
          activeId={activeId}
          setActiveId={setActiveId}
        />
      )}

      {/* Load the desired analytics RAFCE */}
      <div className="h-full w-full pl-2">
        {/* <ClientSummaryReport /> */}
        {firstLoad && switchForAnalytics(activeId)}
      </div>
    </div>
  );
};

export default AnalyticsIndex;
